export default __webpack_public_path__ + "static/media/city.87c4fdd5.png";